import Page, {getStaticProps as pageStaticProps} from "./[[...page]]";

export default Page;

export async function getStaticProps({ preview = false, params }) {
  return await pageStaticProps({
    preview: false,
    params: {
      page: ['404'],
    }
  });
}
